import { render, staticRenderFns } from "./instructionsPdfNew.vue?vue&type=template&id=fbc28250&scoped=true&"
import script from "./instructionsPdfNew.vue?vue&type=script&lang=js&"
export * from "./instructionsPdfNew.vue?vue&type=script&lang=js&"
import style0 from "./instructionsPdfNew.vue?vue&type=style&index=0&id=fbc28250&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc28250",
  null
  
)

export default component.exports